module.exports = __webpack_public_path__ + "static/img/coupon.20af9f7f.png";